import { connect } from 'react-redux';
import decorate from '../../utils/decorate';
import { Map } from 'immutable';
import { request as getWidgetSettings } from '../../modules/system-settings/actions/get-widget-settings';

import DashboardGrid from './DashboardGrid.jsx';

function mapStateToProps(state) {
    return {
        routes: state.routes || Map()
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getWidgetSettings() {
            dispatch(getWidgetSettings());
        }
    };
}

export default decorate(
    connect(mapStateToProps, mapDispatchToProps),
    DashboardGrid
);
